module.exports = __webpack_public_path__ + "static/img/5Gwap.173385a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/5Gwap.png
// module id = PXdH
// module chunks = 0